import { useIonModal } from '@ionic/react'

import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { ManagementUnitsFilterModal } from '@apps-common/components/modals/ManagementUnitsFilterModal'
import { DEFAULT_ACTION_BUTTON_COLOR_CLASSES } from '@apps-common/config/colors'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'
import { IManagementUnitFilterDefaults } from '@apps-common/types/management/unit'

interface IProps {
  defaults?: IManagementUnitFilterDefaults
}

export const ManagementUnitsFilterButton: React.FC<IProps> = ({ defaults }) => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(ManagementUnitsFilterModal, {
    componentProps: {
      defaults
    },
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundArrow
      classes={DEFAULT_ACTION_BUTTON_COLOR_CLASSES}
      iconClasses='text-on-brand'
      Icon={commonIcons.filter}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
    />
  )
}
